import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { notificationEndpoints } from "@/features/notification/api/endpoints";
import type {
  NotificationProviderDto,
  NotificationProviderFilter,
} from "@/features/notification/api/dto";

/**
 * Liste paginée du registre de routage des fournisseurs de transport
 * (`POST /NotificationProviders/all`, guide v2.3 §6.7).
 * Rôles : flashpay-superadmin, flashpay-admin.
 */
export const useNotificationProviders = (
  params: ListRequest<NotificationProviderFilter> = { page: 1, pageSize: 20 }
) =>
  useQuery({
    queryKey: QUERY_KEYS.NOTIFICATION_PROVIDERS_LIST(params),
    queryFn: () =>
      mutateData({
        url: notificationEndpoints.providers.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<NotificationProviderDto>>,
  });
